import { useEffect, useMemo, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Loader2, LinkIcon, ArrowRight } from "lucide-react";
import { fetchShare } from "@/lib/api";
import { StreamReport } from "@/pages/StreamResult";

export default function SharedReport() {
  const { code } = useParams();
  const [data, setData] = useState(null);
  const [error, setError] = useState(false);

  useEffect(() => {
    setData(null);
    setError(false);
    fetchShare(code).then(setData).catch(() => setError(true));
  }, [code]);

  const sharedMeta = useMemo(() => (data ? { created_at: data.created_at, expires_at: data.expires_at } : null), [data]);


  if (error) {
    return (
      <div className="mx-auto max-w-2xl px-4 py-24 text-center" data-testid="shared-not-found">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-[#FEF2F2] text-[#C8102E]">
          <LinkIcon className="h-8 w-8" />
        </div>
        <h1 className="mt-6 font-heading text-2xl font-bold text-slate-900">This link isn't available</h1>
        <p className="mt-2 text-slate-600">The report may have expired (links last 90 days) or the code is incorrect.</p>
        <Link to="/calculator" data-testid="shared-not-found-cta"
          className="mt-6 inline-flex items-center gap-2 rounded-md bg-[#C8102E] px-6 py-3 text-sm font-semibold text-white hover:bg-[#A60C24]">
          Calculate your own score <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    );
  }
  if (!data) return <div className="flex justify-center py-24 text-slate-400"><Loader2 className="h-6 w-6 animate-spin" /></div>;

  return <StreamReport streamResult={data.result} profile={data.profile} shared={sharedMeta} />;
}
